import { connect } from 'react-redux';
import { FirstTimeFlag, hasFirstTimeFlag, dropFirstTimeFlag, } from '../../redux/firstTimeFlags';
import { showBackgroundPicker, initializeBackgrounds } from '../redux/actions';
import { canSetCustomBackground } from '../redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return {
        canSetCustomBackground: canSetCustomBackground(state, deviation),
        firstTime: hasFirstTimeFlag(state, FirstTimeFlag.ArtBackgroundNotUsed),
    };
};
var mapDispatchToProps = {
    onInitialize: initializeBackgrounds,
    showBackgroundPicker: showBackgroundPicker,
    recordFirstTimeUse: function () {
        return dropFirstTimeFlag({ flag: FirstTimeFlag.ArtBackgroundNotUsed });
    },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=BackgroundPicker.container.js.map